<template>
  <div class="policy-list" @click="details(options)">
    <div v-if="options.photo.length<1">
      <p class="span-bold SourceHanSansCN">{{ options.title || delHtmlTag(options.keyword) }}</p>
      <p>
        <span class="span-default">{{ options.user_name }}</span>
        <span class="span-default">{{ options.time }}</span>
      </p>
    </div>
    <div v-else-if="options.photo.length<3">
      <el-row>
        <el-col :span="5">
          <el-image :src="options.photo[0]" style="height: 110px;width: 200px" fit="cover"></el-image>
          <i class="iconfont icon-bofang" v-if="options.type==2"></i>
        </el-col>
        <el-col :span="19" style="padding-left: 10px;">
          <p class="p-bold SourceHanSansCN">{{ options.title || delHtmlTag(options.keyword) }}</p>
          <p>
            <span class="span-default">{{ options.user_name }}</span>
            <span class="span-default">{{ options.time }}</span>
          </p>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <p class="span-bold SourceHanSansCN">{{ options.title || delHtmlTag(options.keyword) }}</p>
      <el-row>
        <el-col :span="5" v-for="(photo,index) of options.photo" v-if="index<3" class="imgs">
          <el-image :src="photo" style="height: 110px;width: 200px" fit="cover"/>
        </el-col>
      </el-row>
      <p>
        <span class="span-default">{{ options.user_name }}</span>
        <span class="span-default">{{ options.time }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "policy",
  data() {
    return {
      cid: 0,
    }
  },
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    details(row) {
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      if (row.type == 2) {
        let routeData = this.$router.resolve({
          name: "videoDetails",
          query: {
            id: row.id,
            type: row.type,
          },
          params: {cid: this.cid},
          path: '/article/videoDetails',
        });
        window.open(routeData.href, '_blank')
      } else if (row.method_type == 'policy') {
        let routeData = this.$router.resolve({
          name: "DynamicDetail",
          query: {
            id: row.id,
            type: 3,
          },
          params: {cid: this.cid},
          path: '/article/DynamicDetail',
        });
        window.open(routeData.href, '_blank')
      } else if (row.method_type == 'dynamic') {
        let routeData = this.$router.resolve({
          name: "DynamicDetail",
          query: {
            id: row.id,
            type: 2,
            method_type: row.method_type
          },
          params: {cid: this.cid},
          path: '/article/DynamicDetail',
        });
        window.open(routeData.href, '_blank')
      } else if (row.method_type == 'notice') {
        let routeData = this.$router.resolve({
          name: "DynamicDetail",
          query: {
            id: row.id,
            type: 4,
            method_type: row.method_type
          },
          params: {cid: this.cid},
          path: '/article/DynamicDetail',
        });
        window.open(routeData.href, '_blank')
      } else if (row.method_type == "article") {
        let routeData = this.$router.resolve({
          name: "DynamicDetail",
          query: {
            id: row.id,
            type: 1,
            method_type: row.method_type
          },
          params: {cid: this.cid},
          path: '/article/DynamicDetail',
        });
        window.open(routeData.href, '_blank')
      } else {
        let routeData = this.$router.resolve({
          name: "DynamicDetail",
          query: {
            id: row.id,
            type: row.type,
            method_type: row.method_type
          },
          params: {cid: this.cid},
          path: '/article/DynamicDetail',
        });
        window.open(routeData.href, '_blank')
      }
    },
    delHtmlTag(str) {
      str = str.replace(/\s/g, "")
      return str.replace(/<[^>]+>/g, "");
    }
  }
}
</script>

<style scoped lang="scss">
.policy-list {
  .span-bold {
    font-size: 18px;
    color: #333;
    font-family: 'SourceHanSansCN';
    margin-block-start: 0em;
    margin-block-end: 0em;
  }

  .p-bold {
    font-size: 18px;
    font-weight: 100;
    font-family: 'SourceHanSansCN';
    color: #333;
    margin-block-start: 0em;
    margin-block-end: 0em;
    min-height: 80px;
  }

  .imgs {
    margin-right: 10px;
    margin-top: 10px;
  }

  p {
    font-size: 16px;
    margin-block-start: 10px;
    margin-block-end: 10px;

    .span-red {
      color: #FE273B;
      font-size: 14px;
      padding-right: 20px;
      font-weight: 100;
      font-family: 'SourceHanSansCN';
    }

    .span-default {
      color: #999999;
      font-size: 14px;
      font-family: 'SourceHanSansCN';
      font-weight: 100;
      padding-right: 20px;
    }
  }

  .icon-bofang {
    font-size: 30px;
    color: white;
    position: absolute;
  }

  .el-col-5 {
    width: auto;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
}
</style>